import {useMutation, useQueryClient} from '@tanstack/react-query';

import {
  resetUserOnboardingStatuses,
  ResetUserOnboardingStatusesParams,
} from '../api';
import {QUERY__USER_ONBOARDING_STATUSES} from '../queryKeys';

export const useResetUserOnboardingStatuses = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: ResetUserOnboardingStatusesParams) =>
      resetUserOnboardingStatuses(params),
    onSuccess: (_, {userId}) => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__USER_ONBOARDING_STATUSES, userId],
      });
    },
  });
};
